import * as React from 'react';
import _ = require("lodash");
import SimPlayer from "../../fbobjects/calculation/SimPlayer";
import PlayerItemComponent from "../PlayerItemComponent/index";
import './playerallitemscomponent.css';
import RiotDB from "../../fbobjects/RiotDB";
import Player from "../../fbobjects/Player";

interface PlayerAllItemsComponentProps {
    player:Player;
    level:number;
}

export default class PlayerAllItemsComponent extends React.Component<PlayerAllItemsComponentProps,any> {

    constructor(props:PlayerAllItemsComponentProps){
        super(props);

    }

    gp():PlayerAllItemsComponentProps{
        return this.props;
    }

    renderAllPlayerItems():any[]{
        let renderItems = [];
        let items = this.gp().player.selectedItems;
        let level = this.gp().level;

        for (let i = 0; i < items.length; i++){
            let item = items[i];
            if (level >= item.level){
                renderItems.push(<PlayerItemComponent key={i} item={item} level={level} player={this.gp().player}/>);
            }
            if (renderItems.length > 5){
                return renderItems;
            }
        }
        renderItems.push(<PlayerItemComponent key={'add'} item={'add'} level={level} player={this.gp().player}/>);
        return renderItems;
    }

    render() {
        return (
            <div className="player-all-items-container">
                <div className="text-and-divider">
                    <div className="player-all-items-text">
                        {this.gp().player.selectedChampion}'s Items
                    </div>
                    {/*<div className="player-all-items-divider"/>*/}
                </div>

                <div className="player-all-item-images">
                    {this.renderAllPlayerItems()}
                </div>


            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/PlayerAllItemsComponent/index.tsx